/**
 * 导演交代卡(`VideoDirectorBriefCard`)的纯逻辑 —— 架构 chip 措辞 + 「换进去」换料集运算
 * (W4 批,2026-09-13)。
 */

/** storyBible.architecture_type → 架构 chip 中文(设计稿钉死);缺席/未知 → null 不显。 */
export const ARCHITECTURE_LABELS: Record<string, string> = {
  persuasion: "说服型结构",
  experience: "实地体验",
  story: "故事型",
};

export function architectureLabel(type?: string | null): string | null {
  if (!type) return null;
  return ARCHITECTURE_LABELS[type] ?? null;
}

/** fact id → 展示文本;缺映射显 fid 本身(不许因一个映射漏了就整段消失)。 */
export function factText(fid: string, factTexts?: Record<string, string> | null): string {
  return factTexts?.[fid] ?? fid;
}

/**
 * 「换进去」确认后的新钉选集 ——
 * 被换入的那条排最前,未被让位的原选料保持原有相对顺序跟在后面
 * (任务书 §3:「新选集(被换入+未让位的 selected,保持顺序)」)。
 */
export function swappedFactSet(
  selected: string[],
  incomingFid: string,
  releasedFid: string
): string[] {
  return [incomingFid, ...selected.filter((f) => f !== releasedFid)];
}
